<template>
  <div>
    <van-nav-bar
      title="发票抬头管理"
      left-arrow
      @click-left="back"
      style="font-size: 12px;color: #333333;"
    />
    <div class="invoice-container">
      <!-- 发票抬头列表 -->
      <van-list
        :loading="loading"
        @update:loading="loading = $event"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, index) in invoiceList"
          :key="index"
          :title="item.title"
          :label="item.taxNumber"
          clickable
          @click="selectInvoice(item)"
        >
          <!-- 添加单选按钮和编辑图标 -->
          <template #right-icon>
            <div class="cell-right">
              <van-radio
                :name="item.title"
                v-model="selectedInvoice"
                :checked="isSelected(item)"
              />
              <van-icon
                name="edit"
                class="edit-icon"
                @click.stop="editInvoice(item)"
              />
            </div>
          </template>
        </van-cell>
      </van-list>

      <!-- 温馨提示 -->
      <div class="invoice-tips">
        <p>温馨提示：</p>
        <p>发票抬头管理中最多可添加5个发票抬头。</p>
      </div>

      <!-- 按钮容器 -->
      <div class="button-container">
        <!-- 添加发票抬头按钮 -->
        <van-button type="info" @click="addInvoice">
          添加发票抬头
        </van-button>
        <!-- 选择发票抬头按钮 -->
        <van-button type="info" @click="selectDefault">
          选择发票抬头
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Search, List, Cell, Button, Radio, Icon } from 'vant';
import { mapGetters } from "vuex";

export default {
  name: 'InvoiceManagement',
  components: {
    [NavBar.name]: NavBar,
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
  },
  data() {
    return {
      searchQuery: '', // 搜索条件
      loading: false, // 列表加载状态
      finished: false, // 列表是否加载完毕
      invoiceList: [], // 发票抬头列表
      allInvoiceList: [ // 模拟数据
        { title: '北京弗恩天下信息技术有限公司', taxNumber: '91110115MA006NGD04', invoiceType: '1' },
        { title: '中国****有限公司', taxNumber: '9000********3456', invoiceType: '1' },
        { title: '上海某某科技有限公司', taxNumber: '91310115MA1H7X1234', invoiceType: '1' },
        { title: '赵喜庆', taxNumber: '666666666', invoiceType: '2' },
      ],
      loginInfo: { username: "", password: "" },
      defaultInvoiceHeader: {} // 选择的默认发票抬头
    };
  },
  computed: {
    // 实现 selectedInvoice 的 get 和 set
    selectedInvoice: {
      // getter：从 Vuex 中获取 selectInvoiceHeader 的 taxNumber
      get() {
        return (
          (this.$store.getters['invoice/selectInvoiceHeader'] &&
            this.$store.getters['invoice/selectInvoiceHeader'].title) ||
          ''
        );
      },
      // setter：通过 Vuex mutation 更新 selectInvoiceHeader
      set(value) {
        const selectedItem = this.invoiceList.find(
          (item) => item.title === value
        );
        if (selectedItem) {
          this.$store.commit('invoice/selectInvoiceHeader', selectedItem);
        }
      },
    },
    ...mapGetters({
      trainsLoginInfo: 'tr/trSearchInfo'
    }),
  },
  methods: {
    // 返回是否选中
    isSelected(item) {
      return this.selectedInvoice === item.title;
    },
    back() {
      this.$router.go(-1);
    },
    // 加载更多数据
    onLoad() {
      this.loginInfo = this.trainsLoginInfo['12306Info']

      var params = {
        username: this.loginInfo.trainAccount,
        password: this.loginInfo.password
      }

      this.$api['trQuery/getInvoiceHeaderList'](params).then(res => {

        if (res.errCode == '1') {
          var originalData = res.data.data
          // 使用 map 方法进行转换
          var invoiceOrin = originalData.map(item => ({
            title: item.invoiceHeaderName,
            taxNumber: item.creditCode,
            invoiceType: item.invoiceHeaderType.toString(), // 将数值类型转换成字符串
            defaultFlag: item.defaultFlag
          }));
          this.invoiceList = invoiceOrin
          // 如果为默认抬头的信息存储到 vuex store 中
          invoiceOrin.forEach(item => {
            if (item.defaultFlag) {
              this.selectInvoice(item)
            }
          })

          this.loading = false;
          this.finished = true; // 数据加载完毕
        } else if (res.errCode == '101' || res.errCode == '100') {
          console.log("登录授权失败" + res.tips)
        } else {
          this.$dialog({
            message: res.errMsg
          })
        }
      }).catch(err => {
        this.errorCatch(err)
      })

    },
    // 选择发票抬头
    selectInvoice(item) {
      this.selectedInvoice = item.title; // 绑定 taxNumber
    },
    // 添加发票抬头
    addInvoice() {
      console.log('添加发票抬头');
      // 这里可以跳转到添加页面或弹出添加表单
      this.$router.push('/userCenter/billInvoice/trainsInvoice/invoiceHeaderManage');
    },
    selectDefault() {
      this.$toast.success('选择成功');
      this.back()

    },
    // 编辑发票抬头
    editInvoice(item) {
      console.log('编辑发票抬头:', item);
      // 这里可以跳转到编辑页面或弹出编辑表单
      this.$router.push({
        path: '/userCenter/billInvoice/trainsInvoice/invoiceHeaderManage',
        query: { isEdit: true, editHeader: item }, // 传递当前发票抬头的税号
      });
    },
    errorCatch(err) {
      if (err.errCode == '239001' || err.errCode == '239003') {
        this.$toast.clear()
        this.smsCheckMsg = err.tips
        this.$dialog.alert({
          title: '温馨提示',
          message: '根据铁路局规定，你的账号需要先完成短信核验。',
          confirmButtonText: '去核验',
        }).then(async () => {
          this.$refs['verificate'].toggle()
        })

      } else if (err.errCode == '239002') {
        this.$toast.clear()
        this.$refs['face-detection'].toggle()
      } else if (err.errCode == '101' || err.errCode == '100') {
        console.log("登录授权失败 err catch" + err.tips)
      } else {
        console.log("获取发票抬头列表失败")
      }
    }
  },
  mounted() {
    // 从 Vuex 中获取 selectedInvoice 并初始化选择框的状态
    const selectedInvoice = this.$store.getters['invoice/selectInvoiceHeader'];
    if (selectedInvoice) {
      this.selectedInvoice = selectedInvoice.title; // 绑定 title
    }
  },
};
</script>

<style lang="less" scoped>
.invoice-container {
  padding: 16px;
  background-color: #fff;
}

.invoice-tips {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  margin-top: 16px;
  margin-bottom: 16px;

  p {
    margin-bottom: 8px;
  }
}

.van-cell {
  display: flex;
  align-items: center;
}

.cell-right {
  display: flex;
  align-items: center;
  gap: 8px; /* 单选按钮和编辑图标之间的间距 */
}

.edit-icon {
  font-size: 16px;
  color: #1989fa; /* 编辑图标颜色 */
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: center; /* 水平居中对齐 */
  gap: 20px; /* 按钮之间的空隙 */
  margin-top: 16px; /* 与上方内容的间距 */
}

.button-container .van-button {
  min-width: 120px; /* 设置按钮最小宽度，避免内容过少时按钮过窄 */
}
</style>
